import { useTranslation } from 'react-i18next';

import { StatusDot } from 'common/components/StatusDot';
import {
    ETrainingAvailabilityStatus,
    getTrainingAvailability,
} from 'training/utils/availability';

interface IProps {
    isActive: boolean;
    startDate?: string | null;
    endDate?: string | null;
}

/**
 * Shows a training's availability as a colored status dot with a label
 * (inactive, always available, available from a date, or a date range).
 */
export const TrainingAvailability = ({
    isActive,
    startDate,
    endDate,
}: IProps) => {
    const [translate] = useTranslation();

    const availability = getTrainingAvailability({
        isActive,
        startDate,
        endDate,
    });

    const availabilityLabel = {
        [ETrainingAvailabilityStatus.Inactive]: translate('inactive'),
        [ETrainingAvailabilityStatus.Always]: translate(
            'trainingsManagementPage.availabilityStatus.always'
        ),
        [ETrainingAvailabilityStatus.From]: translate(
            'trainingsManagementPage.availabilityStatus.from',
            {
                date: availability.startDate,
                interpolation: { escapeValue: false },
            }
        ),
        [ETrainingAvailabilityStatus.Until]: translate(
            'trainingsManagementPage.availabilityStatus.until',
            {
                endDate: availability.endDate,
                interpolation: { escapeValue: false },
            }
        ),
        [ETrainingAvailabilityStatus.Range]: translate(
            'trainingsManagementPage.availabilityStatus.range',
            {
                startDate: availability.startDate,
                endDate: availability.endDate,
                interpolation: { escapeValue: false },
            }
        ),
    }[availability.status];

    return (
        <StatusDot color={availability.color}>{availabilityLabel}</StatusDot>
    );
};
